import { render } from "./ShowBhavaChart.vue?vue&type=template&id=af533398&scoped=true"
import script from "./ShowBhavaChart.vue?vue&type=script&lang=js"
export * from "./ShowBhavaChart.vue?vue&type=script&lang=js"

import "./ShowBhavaChart.vue?vue&type=style&index=0&id=af533398&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af533398"]])

export default __exports__